/* PDP clone kit – main product section (gallery, nutrition popup, Add to cart). Loaded only by sections/pdp-main.liquid.
   No scroll listeners for visibility and no idle loops: everything here runs on a click, a swipe or a variant change. */
(function () {
  'use strict';
  var PDP = window.PDP || {};
  var define = PDP.define || function (n, c) { if (window.customElements && !customElements.get(n)) customElements.define(n, c); };

  /* ---------------- Gallery: a scroll-snap track of square images. The next arrow moves one image and wraps around
     at the end; a thumbnail jumps to its image and the selected thumbnail moves to the start of its row. Swiping uses
     the track's own scrolling; the selected image follows from an IntersectionObserver. ---------------- */
  define('pdp-gallery', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('[data-track]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-slide]'));
      this.thumbs = Array.prototype.slice.call(this.querySelectorAll('[data-thumb]'));
      this.thumbWrap = this.querySelector('[data-thumbs]');
      this.index = 0;
      var next = this.querySelector('[data-next]');
      if (next) next.addEventListener('click', function () { self.goTo((self.index + 1) % self.slides.length); });
      // the selected thumbnail does nothing (like the original's)
      this.thumbs.forEach(function (t) { t.addEventListener('click', function () { var i = parseInt(t.dataset.thumb, 10); if (i !== self.index) self.goTo(i); }); });
      if ('IntersectionObserver' in window && this.slides.length > 1) {
        this._io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) self.mark(self.slides.indexOf(en.target));
          });
        }, { root: this.track, threshold: [0.6] });
        this.slides.forEach(function (s) { self._io.observe(s); });
      }
    }
    disconnectedCallback() { if (this._io) this._io.disconnect(); }
    mark(i) {
      if (i < 0 || i === this.index && this._marked) return;
      this._marked = true;
      this.index = i;
      this.thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      var thumb = this.thumbs[i], wrap = this.thumbWrap;
      // the selected thumbnail moves to the start of its own row (never scrolls the page)
      if (thumb && wrap && wrap.scrollWidth > wrap.clientWidth + 2) {
        wrap.scrollTo({ left: Math.max(0, thumb.offsetLeft - wrap.offsetLeft), behavior: PDP.reduceMotion ? 'auto' : 'smooth' });
      }
    }
    goTo(i) {
      var s = this.slides[i];
      if (!s) return;
      this.track.scrollTo({ left: s.offsetLeft - this.slides[0].offsetLeft, behavior: PDP.reduceMotion ? 'auto' : 'smooth' });
      this.mark(i);
    }
    goToMediaId(id) {
      if (!id) return;
      for (var k = 0; k < this.slides.length; k++) {
        if (this.slides[k].dataset.mediaId === String(id)) { this.goTo(k); return; }
      }
    }
  });

  /* ---------------- Label button: opens its image in a modal <dialog>; the close button, a click outside the image or
     Esc closes it. The image is lazy, so it only loads when opened. ---------------- */
  document.addEventListener('click', function (e) {
    var opener = e.target.closest && e.target.closest('[data-guide-open]');
    if (opener) {
      var d = opener._guide || opener.parentElement.querySelector('[data-guide]');
      // the popup lives under <body> once opened (outside the section, like a portal); the button keeps a reference
      if (d && d.parentElement !== document.body) { opener._guide = d; document.body.appendChild(d); }
      if (d && !d.open) {
        d.showModal();
        var img = d.querySelector('img[loading="lazy"]');
        if (img) img.loading = 'eager';
      }
      return;
    }
    var dlg = e.target.closest && e.target.closest('[data-guide]');
    if (dlg && (e.target === dlg || e.target.closest('[data-guide-close]'))) dlg.close();
  });

  /* ---------------- Add to cart ----------------
     The first state is rendered by Liquid. When the product has more than one variant, Shrine's variant picker does
     the rest like on Shrine's own product page: it sets the form's id input, re-renders the price and switches the
     button between its "Add to cart" / "Sold out" states. This keeps the block's own button labels, updates the
     instalment line from the new price and shows the variant's image when that setting is on. */
  define('pdp-buy', class extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.main = this.closest('pdp-main') || document;
      this.atc = this.querySelector('[data-atc]');
      this.label = this.atc && this.atc.querySelector('.pdp-atc__label');
      if (this.label && window.MutationObserver) {
        this._mo = new MutationObserver(function () { self.syncLabel(); });
        this._mo.observe(this.label, { childList: true, characterData: true, subtree: true });
      }
      this.addEventListener('change', function (e) {
        if (e.target && e.target.matches && e.target.matches('[data-variant-input]')) self.onVariant();
      });
      var picker = this.main.querySelector && this.main.querySelector('variant-selects');
      if (picker) picker.addEventListener('change', function () { setTimeout(function () { self.onVariant(); }, 0); });
    }
    disconnectedCallback() { if (this._mo) this._mo.disconnect(); }
    syncLabel() {
      // Shrine writes its own strings into the label; the block's labels win.
      var s = window.variantStrings || {};
      var text = this.label.textContent.trim();
      var want = text === s.addToCart ? this.atc.dataset.label : text === s.soldOut ? this.atc.dataset.soldout : text;
      if (want && want !== text) this.label.textContent = want;
    }
    onVariant() {
      var picker = this.main.querySelector('variant-selects');
      var v = picker && picker.currentVariant;
      if (!v) return;
      var pay = this.main.querySelector('[data-pay4]');
      if (pay && window.Shopify && Shopify.formatMoney && pay.dataset.template) {
        pay.textContent = pay.dataset.template.replace('[amount]', Shopify.formatMoney(Math.floor(v.price / (+pay.dataset.pay4 || 4))));
      }
      if (this.main.dataset && this.main.dataset.switchMedia === 'true') {
        var g = this.main.querySelector('pdp-gallery');
        if (v.featured_media && g && g.goToMediaId) g.goToMediaId(v.featured_media.id);
      }
    }
  });
})();
